import { TILE_LIBRARY_TYPES } from '../../../state/map/tiles/constants';
import RegionDefinition from './RegionDefinition';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [TILE_LIBRARY_TYPES.LEAFLET]: RegionDefinition,
  [TILE_LIBRARY_TYPES.JSLA]: RegionDefinition,
};
